import { useConfig } from '@/composables';

const remoteHazardAssetsUrl = useConfig().value.remoteHazardAssets.iconAssetsPathSvg;

export const CENTRE_HAZARD_ICONS = {
  'ew-reception-centre': `${remoteHazardAssetsUrl}/ew-reception-centre.svg?url`,
  'ew-evacuation-supports': `${remoteHazardAssetsUrl}/ew-evacuation-supports.svg?url`,

  // Generic Centre
  'ew-generic-centre': `${remoteHazardAssetsUrl}/ew-generic-centre.svg?url`,
  'ew-other-centre': `${remoteHazardAssetsUrl}/ew-other-centre.svg?url`,
  // TODO: This is temporarily added to support the release by duplicating the old icons
  // as some events needed to be republished to show the new icon names.
  'ew-evacuation-centre': `${remoteHazardAssetsUrl}/ew-reception-centre.svg?url`,
  'ew-respite-centre': `${remoteHazardAssetsUrl}/ew-evacuation-supports.svg?url`,
};
